import { BffUsersClient } from '@/application/services/evaluations/apis/bff-users-client';

export class ShortNameService {
  async getShortName(evaluatorId) {
    if (evaluatorId) {
      const bffUsersService = new BffUsersClient();
      const userInfo = await bffUsersService.fullNameById(evaluatorId);
      return userInfo.fullName;
    }
    return 'Automática';
  }
}
